import React, { useCallback } from 'react';
import { Upload } from 'lucide-react';

interface FileUploadProps {
  onFileSelect: (file: File) => void;
  className?: string;
}

export const FileUpload: React.FC<FileUploadProps> = ({ onFileSelect, className = "" }) => {
  const handleDragOver = useCallback((e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
  }, []);

  const handleDrop = useCallback((e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const file = e.dataTransfer.files[0];
      if (file.type.startsWith('image/')) {
        onFileSelect(file);
      }
    }
  }, [onFileSelect]);

  const handleInputChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      onFileSelect(e.target.files[0]);
    }
  }, [onFileSelect]);

  return (
    <div
      className={`relative border border-dashed border-ink/25 hover:border-accent hover:bg-white transition-all duration-300 cursor-pointer group overflow-hidden flex flex-col items-center justify-center bg-white/60 rounded-2xl ${className}`}
      onDragOver={handleDragOver}
      onDrop={handleDrop}
      onClick={() => document.getElementById('fileInput')?.click()}
    >
      <input
        type="file"
        id="fileInput"
        className="hidden"
        accept="image/*"
        onClick={(event) => event.stopPropagation()}
        onChange={handleInputChange}
      />

      <div className="flex flex-col items-center justify-center z-10 p-8 text-center">
        <div className="w-14 h-14 rounded-2xl bg-accent/10 text-accent flex items-center justify-center mb-5 group-hover:bg-accent group-hover:text-white transition-all shadow-[0_4px_14px_-4px_rgba(241,110,0,0.25)]">
          <Upload className="w-6 h-6" strokeWidth={1.75} />
        </div>

        <button
          type="button"
          className="staging-primary-action mb-3"
          onClick={(event) => { event.stopPropagation(); document.getElementById('fileInput')?.click(); }}
        >
          <Upload size={18} /> Foto uploaden
        </button>
        <p className="text-sm text-ink/60 mb-4">
          Sleep je foto hierheen of klik om te kiezen
        </p>
        <p className="text-[11px] text-ink/45 leading-relaxed">
          JPG, PNG of WEBP · 1 foto per upload · geen collages
        </p>
      </div>
    </div>
  );
};